export function copyCollection<T>(value: T[]) {
  return value?.map((x) => ({
    ...x,
  }));
}

export function updateCollection<T>(
  current: T[],
  updated: T[],
  lookUpPredicate: (current: T, updated: T) => boolean,
) {
  return current.map((currentItem) => {
    const updatedItem = updated.find((y) => lookUpPredicate(currentItem, y));
    return updatedItem ? updatedItem : currentItem;
  });
}
